export default "__VITE_ASSET__301e019f__"